module.exports = __webpack_public_path__ + "img/icon.mypin.63ce8275.png";